import styled from 'styled-components';

import { getZoneProgramSummary } from './zoneDetailUtils';

const ProgramStatusIcons = ({ swtName, machineMap }) => {
  const summaries = getZoneProgramSummary(machineMap, swtName);

  return (
    <>
      {summaries.map(({ key, meta, activeCount, faultCount }) => (
        <ProgramCell key={key}>
          <StatLabel>{meta.label}</StatLabel>
          <IconWrap>
            <Icon src={meta.icon} alt={meta.label} />
          </IconWrap>

          <DotGrid>
            <DotRow>
              <Dot $active={activeCount > 0} $color="#00bc7d" />
              <DotCount>{activeCount}</DotCount>
            </DotRow>
            <DotRow>
              <Dot $active={faultCount > 0} $color="#ef4444" />
              <DotCount>{faultCount}</DotCount>
            </DotRow>
          </DotGrid>
        </ProgramCell>
      ))}
    </>
  );
};

export default ProgramStatusIcons;

const ProgramCell = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 17px;
  width: 180px;
  height: 81px;
  padding: 16.8px;
  background: var(--switch-panel-bg);
  border: 0.8px solid var(--switch-blue-border);
  border-radius: 14px;
  box-shadow: var(--switch-shadow-soft);
  flex-shrink: 0;
`;
const StatLabel = styled.span`
  color: var(--switch-text-faint);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  white-space: normal;
  text-align: center;
`;
const IconWrap = styled.div`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Icon = styled.img`
  width: 28px;
  height: 28px;
  object-fit: contain;
`;

const DotGrid = styled.div`
  position: absolute;
  top: 35px;
  right: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const DotRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const Dot = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 9999px;
  background: ${({ $active, $color }) => ($active ? $color : 'var(--switch-control-track)')};
  box-shadow: ${({ $active, $color }) =>
    $active ? `0 0 8px ${$color === '#00bc7d' ? 'rgba(16,185,129,0.5)' : 'rgba(239,68,68,0.5)'}` : 'none'};
`;

const DotCount = styled.span`
  font-size: 8px;
  font-weight: 600;
  color: var(--switch-text-faint);
  min-width: 12px;
  text-align: center;
`;
